export default function OfflinePage(props) {
    return <div id="sb-main-content" className="sb-error-container sb-content-width" style={{maxWidth: "600px", padding: "100px 0"}}>
        <div className="sb-error-block">
            <div className="sb-error-message">
                <h3 className="text-danger"><b>You are not connected to the internet.</b></h3>
                <p>
                    Try reconnecting and then reloading this page.
                </p>
                <button
                    className={"btn sb-organization-color-element-bg"}
                    onClick={() => window.location.reload()}
                >Reload</button>
            </div>
        </div>
    </div>
}